import { ParseQuery } from './parse-query';

import { PaymentMethod } from './../data';

export class PaymentMethodQuery extends ParseQuery<PaymentMethod> {
  constructor() {
    super(PaymentMethod);
  }
}